import React from 'react'
import { Link } from 'react-router-dom'
import Navegador from '../components/Navegador'
import TablaCarros from '../components/TablaCarros'
import axios from 'axios'
import ruta from '../routes/api-routes'

class Menu extends React.Component {

    state = {
        buscar: "",
        error: "",
        permitido: false
    }

    // This make a request to the API endpoint
    async componentDidMount() {
        try {
            // This just get data from the API
            const res = await axios.get(ruta.comprobar)
            let data = await res.data
            if(data === "permitido"){
                this.setState({
                    permitido: true
                })                
            }
        } catch (error) {
        }
    }

    render(){
        if(this.state.permitido){
            return (
                <React.Fragment>
                    <Navegador
                    usernameClass="text-danger px-3"
                    />
                    <div className="container d-flex justify-content-between mt-4">
                        <h3>Menú de los carros</h3>
                        <div>
                            <Link to="/agregarCarro" className="btn btn-success mx-2">Agregar nuevo carro</Link>
                        </div>
                    </div>
                    <TablaCarros/>
                </React.Fragment>
            )
        }
        else {
            return(
                <React.Fragment>
                    <Navegador/>
                    <div className="container d-flex align-items-baseline justify-content-center mt-4">
                        <h5 className="text-muted text-center mx-4">No tienes autorización para modificar los registros</h5>
                        <Link to="/tienda" className="btn btn-danger text-center">Regresar a la tienda</Link>
                    </div>
                </React.Fragment>
            )
        }
    }
}

export default Menu